module.exports = __webpack_public_path__ + "img/logo.a2f32e1c.png";